module.exports = __webpack_public_path__ + "static/media/Bothiveweb.449c4824.png";